import React from 'react'

type PartnerIconProps = {
  size?: number
  color?: string
}

const Partner: React.FC<PartnerIconProps> = ({
  size = 24,
  color = 'currentColor',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 6H16V4C16 2.89 15.11 2 14 2H10C8.89 2 8 2.89 8 4V6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM10 4H14V6H10V4ZM20 19H4V8H20V19Z"
      fill={color}
    />
    <path
      d="M12 12C13.1 12 14 11.1 14 10S13.1 8 12 8 10 8.9 10 10 10.9 12 12 12ZM12 13.5C10.67 13.5 8 14.17 8 15.5V16.5H16V15.5C16 14.17 13.33 13.5 12 13.5Z"
      fill={color}
    />
  </svg>
)

export default Partner
